import React from "react";
import { ALLOWED_POST_AND_CHAT_ROLES } from "features/BrandedCommunity/constants/BrandedCommunity.constants";

export { ALLOWED_POST_AND_CHAT_ROLES };

export const CAN_CUSTOMERS_CHAT_OPTIONS = [
  {
    label: "Everyone can send messages",
    value: ALLOWED_POST_AND_CHAT_ROLES.EVERYONE,
  },
  {
    label: "Only Moderators and I can send messages",
    value: ALLOWED_POST_AND_CHAT_ROLES.MODERATORS,
  },
  {
    label: "Only I can send messages",
    value: ALLOWED_POST_AND_CHAT_ROLES.ONLY_CREATOR,
  },
];

export const CHANNEL_ACCESS_TYPES = {
  PUBLIC: 1,
  PRIVATE: 2,
  SECRET: 3,
};

export const CHANNEL_ACCESS_TYPES_LABELS = {
  [CHANNEL_ACCESS_TYPES.PUBLIC]: "Open",
  [CHANNEL_ACCESS_TYPES.PRIVATE]: "Private",
  [CHANNEL_ACCESS_TYPES.SECRET]: "Secret",
};

export const ACCESS_TYPE_OPTIONS = [
  {
    label: CHANNEL_ACCESS_TYPES_LABELS[CHANNEL_ACCESS_TYPES.PUBLIC],
    value: CHANNEL_ACCESS_TYPES.PUBLIC,
  },
  {
    label: CHANNEL_ACCESS_TYPES_LABELS[CHANNEL_ACCESS_TYPES.PRIVATE],
    value: CHANNEL_ACCESS_TYPES.PRIVATE,
  },
  {
    label: CHANNEL_ACCESS_TYPES_LABELS[CHANNEL_ACCESS_TYPES.SECRET],
    value: CHANNEL_ACCESS_TYPES.SECRET,
  },
];

export const ACCESS_TYPE_INFO = {
  [CHANNEL_ACCESS_TYPES.PUBLIC]: (
    <div>
      <strong>Accessible to everyone.</strong> All members can see this channel.
    </div>
  ),
  [CHANNEL_ACCESS_TYPES.PRIVATE]: (
    <div>
      <strong>Invited members only.</strong> Non-members will see a locked page
      and a message that you customise below.
    </div>
  ),
  [CHANNEL_ACCESS_TYPES.SECRET]: (
    <div>
      <strong>Invited members only.</strong> Non-members will not see this
      channel.
    </div>
  ),
};
